import React from 'react';
import { IShipmentProject } from '/imports/api/shipmentProject/interfaces/ShipmentProject';


interface IShipmentProjectInfoTagProps extends Pick<IShipmentProject,
  | "id"
  | "type"
  | "title"
  | "year"
  | "status"> { }

const ShipmentProjectInfoTag: React.FunctionComponent<IShipmentProjectInfoTagProps> = ({ type, title, year, status }) => {
  if (!type) return ` - `;
  return <>
    {type.code} - {title} <span style={{ opacity: 0.5 }}>{year}</span>
  </>
};

export default ShipmentProjectInfoTag;
